export const BETWEEN_HOURS = 'BETWEEN_HOURS';
export const MENU_HOURS_EXPIRED = 'MENU_HOURS_EXPIRED';
export const CHANGE_LOCATION = 'CHANGE_LOCATION';
export const CART_ITEMS_EXPIRED = 'CART_ITEMS_EXPIRED';
